import React from 'react';

const PushNotification = () => {
    return (
        <div>

        </div>
    );
};

export default PushNotification;